import { APIMethod, fetchData } from "@client";

export async function createProjectVersionComment(
  projectUuid,
  userUuid,
  versionKey,
  path,
  taskName,
  body,
  mentions,
  internal,
  parent,
) {
  const res = await fetchData(
    "v1/ws/project/comments",
    APIMethod.POST,
    {
      removeEmptyKeys: true,
      data: {
        uuid: projectUuid,
        user: userUuid,
        version: versionKey,
        path,
        name: taskName,
        body,
        notify: mentions ? JSON.stringify(mentions) : undefined,
        parent,
        internal: internal ? 1 : 0,
      }
    }
  );
  return res.results;
}